import useSWR from "swr";

import { api, createDeviceIsActiveUrl } from "@is/services/api";

type Response = {
  isActive: boolean;
};

type Props = {
  deviceId: string;
  storeId: string;
};

export const useDeviceIsActive = ({ deviceId, storeId }: Props) => {
  const url = createDeviceIsActiveUrl(storeId, deviceId);

  const { data, error, isLoading } = useSWR(
    deviceId && storeId && url,
    api.get
  );

  return {
    data: data as Response,
    isLoading,
    error,
  };
};
